import { useMemo } from 'react'
import { MantineReactTable, MRT_ColumnDef, useMantineReactTable } from 'mantine-react-table'
import { tableDefaultAlertBannerProps, tableDefaultProps } from '@shared/components/table/table'
import { NoDataMessage } from '@shared/components/table/table-no-data-message'
import { WoolContractAdditionalDetail } from '@shared/components/wool-data/wool-contracts-table/contract-details-helpers'

type ContractDetailsSubtableProps = {
  data: WoolContractAdditionalDetail[]
  noDataMessage?: string
  isLoading?: boolean
  isError?: boolean
}

export const ContractDetailsSubtable = ({
  data,
  noDataMessage = 'No values to display',
  isLoading,
  isError,
}: ContractDetailsSubtableProps) => {
  const columns = useMemo<MRT_ColumnDef<WoolContractAdditionalDetail>[]>(
    () => [
      {
        id: 'key',
        accessorKey: 'key',
        header: '',
      },
      {
        id: 'target',
        accessorKey: 'target',
        header: 'Target',
        mantineTableHeadCellProps: {
          align: 'right',
        },
        mantineTableBodyCellProps: {
          align: 'right',
        },
      },
      {
        id: 'range',
        accessorKey: 'range',
        header: 'Range',
        mantineTableHeadCellProps: {
          align: 'right',
        },
        mantineTableBodyCellProps: {
          align: 'right',
        },
      },
    ],
    []
  )

  const table = useMantineReactTable({
    ...tableDefaultProps,
    columns,
    data,
    state: {
      isLoading,
      showAlertBanner: isError,
    },
    mantineToolbarAlertBannerProps: tableDefaultAlertBannerProps(isError),
    renderEmptyRowsFallback: () => <NoDataMessage noDataMessage={noDataMessage} />,
    mantineTableProps: {
      ...tableDefaultProps.mantineTableProps,
      'aria-label': 'Contract details',
    },
    enablePagination: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
  })

  return <MantineReactTable table={table} />
}
